<template>
  <section>
    <ManageDepositsTable
      flush-heading
      v-if="accountId"
      :accountId="accountId"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import ManageDepositsTable from '@/components/manage/deposit/ManageDepositsTable.vue';
import { setTitle } from '@/utils/title';

export default {
  components: { ManageDepositsTable },

  computed: {
    ...mapGetters({
      accountId: 'auth/accountId',
    }),
  },

  created() {
    setTitle('Deposits');
  },
};
</script>
